// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"440":"4674c4fb15e22e692a3c","581":"db5bfa1541892212b0f1"}[chunkId] + ".js";
};